(() => {
  const products = window.JZ_PRODUCTS || [];
  if (!products.length) return;

  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }

  const homeView = document.querySelector('[data-view="home"]');
  const detailView = document.querySelector('[data-view="detail"]');
  const storyPageView = document.querySelector('[data-view="story"]');
  const howtoView = document.querySelector('[data-view="howto"]');
  const legalView = document.querySelector('[data-view="legal"]');
  const LEGAL_SLUGS = ["privacy", "terms", "cookies", "returns"];
  const navLinks = document.querySelectorAll(".nav-links a[data-nav]");
  const grid = document.querySelector("#productGrid");
  const storyEyebrow = document.querySelector("#storyEyebrow");
  const storyTitle = document.querySelector("#storyTitle");
  const storyText = document.querySelector("#storyText");
  const storyMore = document.querySelector("#storyMore");
  const storySection = document.querySelector(".detail-story");
  const storyFigure = document.querySelector("#storyFigure");
  const storyImage = document.querySelector("#storyImage");
  const storyCaption = document.querySelector("#storyCaption");
  const detailImage = document.querySelector("#detailImage");
  const detailTitle = document.querySelector("#detailTitle");
  const detailChinese = document.querySelector("#detailChinese");
  const detailPrice = document.querySelector("#detailPrice");
  const detailNote = document.querySelector("#detailNote");
  const detailSpecs = document.querySelector("#detailSpecs");
  const thumbStrip = document.querySelector("#thumbStrip");
  const addToCart = document.querySelector("#addToCart");
  const cartCount = document.querySelector("#cartCount");
  const toast = document.querySelector("#toast");

  let activeProduct = products[0];

  function priceValue(product) {
    return parseFloat(String(product.price || "").replace(/[^0-9.]/g, "")) || undefined;
  }

  function gaEvent(name, params) {
    if (typeof window.gtag === "function") window.gtag("event", name, params);
  }

  function imagesFor(product) {
    return product.images && product.images.length
      ? product.images
      : [{ src: product.image, pos: "center" }];
  }

  function renderProducts() {
    grid.innerHTML = products
      .map(
        (product) => `
          <button class="product-card" type="button" data-product-id="${product.id}" aria-label="Open ${product.title}">
            <div class="product-media">
              <img src="${product.image}" alt="${product.title}">
            </div>
            <div class="product-info">
              <header>
                <div>
                  <h3>${product.title}</h3>
                  <small>${product.chinese}</small>
                </div>
                <span class="price">${product.price}</span>
              </header>
              <p class="product-note">${product.note}</p>
            </div>
          </button>
        `
      )
      .join("");
    if (homeView) homeView.classList.toggle("is-single", products.length === 1);
  }

  function renderDetail(product) {
    activeProduct = product;
    storyEyebrow.textContent = product.storyEyebrow;
    storyTitle.textContent = product.storyTitle;
    storyText.textContent = product.storyText;
    if (storyMore) {
      storyMore.textContent = product.storyMore || "";
      storyMore.hidden = !product.storyMore;
    }
    if (storyFigure && storyImage) {
      if (product.storyImage) {
        storyImage.src = product.storyImage;
        storyImage.alt = product.storyCaption || product.storyTitle;
        if (storyCaption) storyCaption.textContent = product.storyCaption || "";
        storyFigure.hidden = false;
        storySection?.classList.remove("no-figure");
      } else {
        storyFigure.hidden = true;
        storySection?.classList.add("no-figure");
      }
    }
    detailTitle.textContent = product.title;
    detailChinese.textContent = product.chinese;
    if (detailPrice) detailPrice.textContent = product.price;
    if (detailNote) detailNote.textContent = product.note || "";

    const images = imagesFor(product);
    detailImage.src = images[0].src;
    detailImage.alt = product.title;
    detailImage.style.setProperty("--detail-pos", images[0].pos);

    detailSpecs.innerHTML = Object.entries(product.specs || {})
      .map(([key, value]) => `<div><dt>${key}</dt><dd>${value}</dd></div>`)
      .join("");

    thumbStrip.innerHTML = images
      .map(
        (image, index) => `
          <button type="button" class="${index === 0 ? "active" : ""}" data-image-index="${index}" aria-label="Show ${product.title} image ${index + 1}">
            <img src="${image.src}" alt="" style="--pos: ${image.pos}">
          </button>
        `
      )
      .join("");

    if (addToCart) {
      const label = addToCart.querySelector(".label");
      const purchasable = product.available && product.variantId;
      addToCart.disabled = !purchasable;
      if (label) label.textContent = purchasable ? "Add to cart" : "Sold out";
    }
  }

  function setActiveNav(name) {
    navLinks.forEach((a) => a.classList.toggle("active", a.dataset.nav === name));
  }

  function showHome({ replace = false } = {}) {
    detailView.hidden = true;
    if (storyPageView) storyPageView.hidden = true;
    if (howtoView) howtoView.hidden = true;
    if (legalView) legalView.hidden = true;
    setActiveNav("home");
    homeView.hidden = false;
    if (replace) history.replaceState(null, "", "#home");
    else history.pushState(null, "", "#home");
    window.scrollTo(0, 0);
  }

  function showDetail(product, { replace = false } = {}) {
    renderDetail(product);
    homeView.hidden = true;
    if (storyPageView) storyPageView.hidden = true;
    if (howtoView) howtoView.hidden = true;
    if (legalView) legalView.hidden = true;
    setActiveNav("home");
    detailView.hidden = false;
    window.scrollTo(0, 0);
    gaEvent("view_item", {
      currency: "USD",
      value: priceValue(product),
      items: [{ item_id: product.id, item_name: product.title, price: priceValue(product) }],
    });
    if (replace) history.replaceState(null, "", `#${product.id}`);
    else history.pushState(null, "", `#${product.id}`);
  }

  function showStory({ replace = false } = {}) {
    homeView.hidden = true;
    detailView.hidden = true;
    if (howtoView) howtoView.hidden = true;
    if (storyPageView) storyPageView.hidden = false;
    setActiveNav("our-story");
    if (replace) history.replaceState(null, "", "#our-story");
    else history.pushState(null, "", "#our-story");
    window.scrollTo(0, 0);
  }

  function showHowTo({ replace = false } = {}) {
    homeView.hidden = true;
    detailView.hidden = true;
    if (storyPageView) storyPageView.hidden = true;
    if (legalView) legalView.hidden = true;
    if (howtoView) howtoView.hidden = false;
    setActiveNav("how-to-tell");
    if (replace) history.replaceState(null, "", "#how-to-tell");
    else history.pushState(null, "", "#how-to-tell");
    window.scrollTo(0, 0);
  }

  function showLegal(slug, { replace = false } = {}) {
    homeView.hidden = true;
    detailView.hidden = true;
    if (storyPageView) storyPageView.hidden = true;
    if (howtoView) howtoView.hidden = true;
    if (legalView) {
      legalView.hidden = false;
      legalView.querySelectorAll("[data-legal]").forEach((doc) => {
        doc.hidden = doc.dataset.legal !== slug;
      });
    }
    setActiveNav("");
    if (replace) history.replaceState(null, "", `#${slug}`);
    else history.pushState(null, "", `#${slug}`);
    window.scrollTo(0, 0);
  }

  function routeFromHash() {
    const id = window.location.hash.replace("#", "");
    if (id === "our-story" && storyPageView) {
      showStory({ replace: true });
      return;
    }
    if (id === "how-to-tell" && howtoView) {
      showHowTo({ replace: true });
      return;
    }
    if (LEGAL_SLUGS.indexOf(id) !== -1 && legalView) {
      showLegal(id, { replace: true });
      return;
    }
    const product = products.find((item) => item.id === id);
    if (product) showDetail(product, { replace: true });
    else showHome({ replace: true });
  }

  function showToast(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add("show");
    window.clearTimeout(showToast.timeout);
    showToast.timeout = window.setTimeout(() => toast.classList.remove("show"), 1800);
  }

  grid.addEventListener("click", (event) => {
    const card = event.target.closest("[data-product-id]");
    if (!card) return;
    const product = products.find((item) => item.id === card.dataset.productId);
    if (product) showDetail(product);
  });

  document.querySelector("#backHome")?.addEventListener("click", () => showHome());

  thumbStrip.addEventListener("click", (event) => {
    const thumb = event.target.closest("[data-image-index]");
    if (!thumb) return;
    const image = imagesFor(activeProduct)[Number(thumb.dataset.imageIndex)];
    detailImage.src = image.src;
    detailImage.style.setProperty("--detail-pos", image.pos);
    thumbStrip.querySelectorAll("button").forEach((button) => button.classList.remove("active"));
    thumb.classList.add("active");
  });

  addToCart?.addEventListener("click", () => {
    if (!activeProduct || !activeProduct.variantId || addToCart.disabled) return;
    const label = addToCart.querySelector(".label");
    const previous = label ? label.textContent : "";
    addToCart.disabled = true;
    if (label) label.textContent = "Adding…";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: activeProduct.variantId, quantity: 1 }] }),
    })
      .then((response) => {
        if (!response.ok) throw new Error("add failed");
        return fetch("/cart.js");
      })
      .then((response) => response.json())
      .then((cart) => {
        if (cartCount) cartCount.textContent = cart.item_count;
        gaEvent("add_to_cart", {
          currency: "USD",
          value: priceValue(activeProduct),
          items: [{ item_id: activeProduct.id, item_name: activeProduct.title, price: priceValue(activeProduct), quantity: 1 }],
        });
        showToast(`${activeProduct.title} added to your cart`);
      })
      .catch(() => showToast("Sorry — could not add this to your cart"))
      .finally(() => {
        addToCart.disabled = false;
        if (label) label.textContent = previous;
      });
  });

  window.addEventListener("popstate", routeFromHash);
  window.addEventListener("hashchange", routeFromHash);

  renderProducts();
  routeFromHash();
})();
